import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {ItemCountView} from '../../ui_canvas_engine/ItemCountView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {PIXI} from '@colonist/pixi'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {TranslationObject} from '@colonist/i18n'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sprites} from '../UIGameImageDictionary'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CardEnum} from '@colonist/game-states'

export abstract class UIGamePlayerInformationLargestArmyView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    readonly playerState: PlayerValidator
    protected readonly playerInformation: UIGamePlayerInformationView
    protected largestArmyView: ItemCountView

    protected readonly largestArmyTexture: PIXI.Texture
    private readonly largestArmyHighlightTexture: PIXI.Texture

    constructor(uiGameManager: UIGameManager, playerState: PlayerValidator) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerState = playerState

        this.largestArmyTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_largest_army)
        this.largestArmyHighlightTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_largest_army_highlight)

        const playerInformation = this.uiGameManager.playersController?.getPlayerInformationViewWithColor(this.playerState.color)
        if(playerInformation == undefined) return
        this.playerInformation = playerInformation

        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        const isMyPlayer = this.playerInformation.player.color == bottomPlayerColor
        isMyPlayer ? this.createMyLargestArmyView() : this.createOpponentLargestArmyView()
        this.createTooltip()
        this.updateLargestArmyCount()
    }

    private createTooltip() {
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
        const largestArmyViewTipTitle: TranslationObject = {key: 'strings:game.playerInformation.largestArmy.title'}
        const largestArmyViewTipBody: TranslationObject = {key: 'strings:game.playerInformation.largestArmy.body'}
        this.largestArmyView.view.setTip(largestArmyViewTipTitle, [largestArmyViewTipBody])
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateLargestArmyCount(); break
            default: break
        }
    }

    protected abstract createMyLargestArmyView()
    protected abstract createOpponentLargestArmyView()

    private updateLargestArmyCount() {
        if(this.playerInformation == undefined) return
        const developmentCardsUsed = this.playerInformation.developmentCardsPlayerState?.developmentCardsUsed ?? []
        const knightDevelopmentCardsUsedCount = ArrayUtils.countOccurenceOfValueInArray(developmentCardsUsed, CardEnum.Knight)
        this.largestArmyView.updateText({key: 'strings:colonistCommon.utils.#buffer', options: {value: knightDevelopmentCardsUsedCount}})
        const hasLargestArmy = this.playerInformation.largestArmyPlayerState?.hasLargestArmy ?? false
        hasLargestArmy ? this.largestArmyView.view.updateTexture(this.largestArmyHighlightTexture) : this.largestArmyView.view.updateTexture(this.largestArmyTexture)
    }

    destroy() {
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
